module.exports = __webpack_public_path__ + "media/images/advisor/img_1_0-fc4513e2a7dfd32c9bb35dbe0b3640e0.png";